(function ($) {
    $(function () {
        var $smava = $('#smava-blocked');
        $smava.on('unblocked', function (enable) {
            // load the necessary scripts
            $.when($.ajax({
                url: 'https://frame.smava.de/main.js',
                dataType: 'script',
            }), $.ajax({
                url: 'https://widget.smava.de/embedTeal.js',
                dataType: 'script',
            })).done(function () {
                window.teal_embed_iframe({
                    advertisementId: 'd5LLQSXmQjPe',
                    elementId: 'teal-embed-iframe',
                    data: {
                        amount: 20000,
                        term: 84,
                        purpose: 'OTHER',
                        palette: {
                            primary: {
                                light: '#f2f2f2',
                                main: '#000000',
                                dark: '#000000',
                                contrastText: '#fff',
                            },
                            secondary: {
                                light: '#BFBFBF',
                                main: '#979797',
                                dark: '#707070',
                                contrastText: 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    },
                    entryPoint: 'first',
                    imodEntryPoint: 'landing_page',
                });
            });
        });
    });
})(jQuery);
